module.exports = __webpack_public_path__ + "static/img/预设话术@2x1.583da7bc.png";